import { initializeBlock } from "./";
import { initializeFrontendBlocks } from "@/scripts/utils/acf-blocks";
import { name } from "./block.json";

initializeFrontendBlocks(name, initializeBlock);
